import CropsChartContainer from './CropsChartContainer';

export default CropsChartContainer;
